import client from "./client";

const getWalletBalance = () =>
  client.get("/subsidiary/dashboard/get/wallet/balance");
  const getWalletHistory = () =>
		client.get('/subsidiary/dashboard/get/wallet/balance/totals');

export default { getWalletBalance, getWalletHistory };
